var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgImms = function SvgImms(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18505",
    "data-name": "Group 18505",
    transform: "translate(21143 -6670)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18490",
    "data-name": "Group 18490",
    transform: "translate(-21143 6670)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11894",
    "data-name": "Group 11894"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11893",
    "data-name": "Group 11893",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7885",
    "data-name": "Path 7885",
    d: "M24.5,0A24.5,24.5,0,1,1,0,24.5,24.5,24.5,0,0,1,24.5,0Z",
    fill: "#f9f9f9"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10873",
    "data-name": "Path 10873",
    d: "M34.238,10.009l.707-.707L28.7,3.056l-.707.707,2.77,2.77-4.155,4.154-4.33-4.33-.707.706,1.207,1.206L9.861,21.187a.5.5,0,0,0-.108.162h0l-2.38,5.787a.5.5,0,0,0,.109.543l1.066,1.066L3.056,34.237l.707.707,5.492-5.492,1.066,1.066a.5.5,0,0,0,.354.146.507.507,0,0,0,.19-.038l5.784-2.378h0l0,0a.488.488,0,0,0,.16-.1L29.73,15.223l1.207,1.207.707-.707-4.331-4.33,4.155-4.154ZM10.792,29.575,8.424,27.208l1.968-4.784,2.593,2.593,2.592,2.592Zm5.669-2.5-2.77-2.77-2.77-2.77L13.058,19.4l1.988,1.988.707-.707-1.988-1.988,1.82-1.821,1.988,1.989.707-.707-1.988-1.989,1.819-1.819,1.99,1.988.707-.708-1.99-1.987,1.82-1.82,1.988,1.99.707-.707-1.988-1.99,2.137-2.137,5.54,5.539Z",
    transform: "translate(-21137 6673.944)",
    fill: "#6c6c6c"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImms, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/imms.9ca192ff.svg";
export { ForwardRef as ReactComponent };